import { Select, ClyCoreConfig } from '@coinlocally/cly-core';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import IRF from 'assets/img/shared/little-iran-flag.svg';
import RUF from 'assets/img/shared/little-russia-flag.svg';
import SPF from 'assets/img/shared/little-spain-flag.svg';
import UKF from 'assets/img/shared/little-uk-flag.svg';
import DEF from 'assets/img/shared/little-germany-flag.svg';
import FRF from 'assets/img/shared/little-france-flag.svg';



export const LocalSelector: React.FC<{ languageList: TLang[] }> = ({ languageList }) => {
	const { i18n } = useTranslation('components/local-selector');
	const location = useLocation();
	const navigate = useNavigate();

	const onChangeLanguageHandler = (lng: string) => {
		if (lng !== i18n.language) {
			ClyCoreConfig.LANGUAGE = lng as any;
			navigate(location.pathname.replace(i18n.language, lng), { replace: true });
			i18n.changeLanguage(lng);
		}
	};
	return (
		<Select
			containerClassName='select_language_container'
			className='select_language'
			id='language'
			list={[
				{
					key: 'en',
					value: { imgUrl: UKF, primaryTxt: 'English' },
				},
				{
					key: 'fa',
					value: { imgUrl: IRF, primaryTxt: 'فارسی' },
				},
				{
					key: 'de',
					value: { imgUrl: DEF, primaryTxt: 'Deutsch' },
				},
				{
					key: 'ru',
					value: { imgUrl: RUF, primaryTxt: 'Русский' },
				},
				{
					key: 'es',
					value: { imgUrl: SPF, primaryTxt: 'Español' },
				},
				{
					key: 'fr',
					value: { imgUrl: FRF, primaryTxt: 'Français' },
				},
			].filter(x => x.key && languageList.includes(x.key as TLang))}
			value={i18n.language}
			onChange={v => onChangeLanguageHandler(v)}
		/>
	);
};
